import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import * as React from 'react';
import { buildMortgageBannerUnderPriceIpotekaUrl } from 'shared/utils/tracking/mortgageUnderPriceCianBanner';

import icon from './assets/discount.svg';
import { TMortgageBannerVerticalName, trackMortgageWidgetAnchorClick, trackMortgageWidgetAnchorShow } from './tracking';
import { EntryPointRow } from '../EntryPointRow';

interface IUiData {
  linkText: string;
  icon: string;
}

interface IMortgageWidgetPromoDiscountProps {
  mortgagePromoDesign: string | null;
  verticalName: TMortgageBannerVerticalName;
}

const defaultData: IUiData = {
  linkText: 'Ипотека',
  icon,
};

export const MortgageWidgetPromoDiscount: React.FC<IMortgageWidgetPromoDiscountProps> = ({ verticalName }) => {
  const redirectPath = buildMortgageBannerUnderPriceIpotekaUrl(verticalName);

  const handleAnchorClick = () => {
    trackMortgageWidgetAnchorClick(verticalName);
  };

  return (
    <ActionAfterViewObserver callback={() => trackMortgageWidgetAnchorShow(verticalName)} callbackDelay={1000}>
      <EntryPointRow
        dark
        onClick={handleAnchorClick}
        imgSrc={defaultData.icon}
        title={defaultData.linkText}
        link={redirectPath}
      />
    </ActionAfterViewObserver>
  );
};
